require('../modules/es.unescape');
var global = require('../internals/global');

module.exports = global.unescape;
